import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { ApprovalMethodNoticePeriodField } from '~/components/agreement-controllers/ApprovalMethodNoticePeriodField/ApprovalMethodNoticePeriodField';
import { useStore } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { approvalMethodNoticePeriodModel } from '~/models';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
export const GetAutoApproveAmendmentsModalContentTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            AutoApproveAmendmentsModalContentTID: {
                Field: 'amendments-auto-approval'
            }
        }
    });
export const GetAutoApproveAmendmentsCellTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            AutoApproveAmendmentsCellTID: {
                Cell: (index)=>"edit-auto-approve-amendments-".concat(index),
                Value: (index)=>"auto-approve-amendments-".concat(index),
                Modal: 'edit-auto-approve-amendments-modal'
            }
        }
    });
const AutoApproveAmendmentsModalContent = (param)=>{
    let { draft, setDraft } = param;
    const { t: cellsTexts } = useLocaleKeys('pages.draftsDashboard.cells');
    const { AutoApproveAmendmentsModalContentTID } = useMemo(()=>GetAutoApproveAmendmentsModalContentTID(), []);
    const userInfo = useStore((state)=>state.userInfo);
    const worksAt = userInfo === null || userInfo === void 0 ? void 0 : userInfo.business();
    const amendmentsAutoApproval = useMemo(()=>{
        var _worksAt_settings;
        const amendmentsApprovalMethod = draft.amendmentsApprovalMethod();
        if (amendmentsApprovalMethod) return approvalMethodNoticePeriodModel.isAutoApproval(amendmentsApprovalMethod);
        if (worksAt === null || worksAt === void 0 ? void 0 : (_worksAt_settings = worksAt.settings) === null || _worksAt_settings === void 0 ? void 0 : _worksAt_settings.amendmentsApprovalMethod) return approvalMethodNoticePeriodModel.isAutoApproval(worksAt.settings.amendmentsApprovalMethod);
        return false;
    }, [
        draft,
        worksAt
    ]);
    const defaultAutoApprovalMethod = draft.defaultAutoApprovalMethod(worksAt);
    const amendmentsAutoApprovalNoticePeriod = useMemo(()=>{
        var _worksAt_settings;
        const amendmentsApprovalMethod = draft.amendmentsApprovalMethod();
        if (amendmentsApprovalMethod && approvalMethodNoticePeriodModel.isAutoApproval(amendmentsApprovalMethod)) return amendmentsApprovalMethod.auto.noticePeriodDays;
        if ((worksAt === null || worksAt === void 0 ? void 0 : (_worksAt_settings = worksAt.settings) === null || _worksAt_settings === void 0 ? void 0 : _worksAt_settings.amendmentsApprovalMethod) && approvalMethodNoticePeriodModel.isAutoApproval(worksAt.settings.amendmentsApprovalMethod)) return worksAt.settings.amendmentsApprovalMethod.auto.noticePeriodDays;
        return 30;
    }, [
        draft,
        worksAt
    ]);
    const getApprovalMethodNoticePeriod = (noticePeriodDays)=>({
            type: 'auto',
            auto: {
                noticePeriodDays
            }
        });
    const manualApprovalMethod = {
        type: 'manual'
    };
    return /*#__PURE__*/ _jsx(ApprovalMethodNoticePeriodField, {
        info: cellsTexts.autoApproveAmendmentsInfoText(),
        text: cellsTexts.autoApproveAmendments(),
        testId: AutoApproveAmendmentsModalContentTID.Field(),
        bi: {
            enabledCheckbox: {
                name: 'amendments_auto_approval_enabled'
            },
            periodSelect: {
                name: 'amendments_auto_approval_period'
            }
        },
        enabled: amendmentsAutoApproval,
        onToggle: ()=>{
            amendmentsAutoApproval ? setDraft(draft.setAmendmentsApprovalMethod(manualApprovalMethod)) : setDraft(draft.setAmendmentsApprovalMethod(getApprovalMethodNoticePeriod(defaultAutoApprovalMethod)));
        },
        noticePeriod: amendmentsAutoApprovalNoticePeriod,
        onChangePeriod: (noticePeriod)=>{
            setDraft(draft.setAmendmentsApprovalMethod(getApprovalMethodNoticePeriod(Number(noticePeriod))));
        }
    });
};
export default function AutoApproveAmendmentsCell(param) {
    let { draft, index, onOpenModal, isDisabled, disabledTooltip } = param;
    const { t: draftCellsTexts } = useLocaleKeys('pages.draftsDashboard.editTable.draftCells');
    const { AutoApproveAmendmentsCellTID } = useMemo(()=>GetAutoApproveAmendmentsCellTID(), []);
    const amendmentsApprovalMethod = draft.amendmentsApprovalMethod();
    const onClick = ()=>onOpenModal({
            renderContent: (param)=>{
                let { draft, setDraft } = param;
                return {
                    title: draftCellsTexts.autoApproveAmendments(),
                    testId: AutoApproveAmendmentsCellTID.Modal(),
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    },
                    content: /*#__PURE__*/ _jsx(AutoApproveAmendmentsModalContent, {
                        draft: draft,
                        setDraft: setDraft
                    })
                };
            }
        });
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: AutoApproveAmendmentsCellTID.Cell(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Typography, {
            testId: AutoApproveAmendmentsCellTID.Value(index),
            children: amendmentsApprovalMethod && approvalMethodNoticePeriodModel.isAutoApproval(amendmentsApprovalMethod) ? draftCellsTexts.autoApprovalNoticePeriod({
                count: amendmentsApprovalMethod.auto.noticePeriodDays
            }) : draftCellsTexts.autoApprovalDisabled()
        })
    });
}
